import { render, staticRenderFns } from "./city-popver-checkbox.vue?vue&type=template&id=31df2679&scoped=true"
import script from "./city-popver-checkbox.vue?vue&type=script&lang=js"
export * from "./city-popver-checkbox.vue?vue&type=script&lang=js"
import style0 from "./city-popver-checkbox.vue?vue&type=style&index=0&id=31df2679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31df2679",
  null
  
)

export default component.exports